/* eslint-disable */
// NB! It is not possible to use object destruction
export const RELATIVES_API_URL = process.env.RELATIVES_API_URL;
export const STORAGE_API_URL = process.env.STORAGE_API_URL;
export const ROCKET_CHAT_SERVICE_DOMAIN = process.env.ROCKET_CHAT_SERVICE_DOMAIN;
export const CHAT_API_URL = process.env.CHAT_API_URL;

export const SENTRY_API_URL = `${process.env.SENTRY_PROTOCOL}://${process.env.SENTRY_KEY}@${process.env.SENTRY_API_URL}/${process.env.SENTRY_PROJECT}`;
